import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const Toast = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={1500}
      hideProgressBar={true}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
      limit={2}
      style={{ top: 0, right: 80 }}
      className="!max-w-[456px] !w-full text-sm toast-wrapper"
      toastClassName="toast-content"
      toastStyle={{
        right: 0
      }}
    />
  );
};

export default Toast;
